/**
 * Typo align
 */
export var TypographyAlign;
(function (TypographyAlign) {
    TypographyAlign["TEXT_CENTERED"] = "has-text-centered";
    TypographyAlign["TEXT_JUSTIFIED"] = "has-text-justified";
    TypographyAlign["TEXT_LEFT"] = "has-text-left";
    TypographyAlign["TEXT_RIGHT"] = "has-text-right";
})(TypographyAlign || (TypographyAlign = {}));
/**
 * Typography Alignment Method (TYPO)
 * @param typo {String} TypographyColor
 */
export const setTypographyAlign = (typo = 'left') => {
    return ((typo && !Array.isArray(typo) && typo === TypographyAlign.TEXT_CENTERED && 'center') ||
        (typo && Array.isArray(typo) && typo.includes(TypographyAlign.TEXT_CENTERED) && 'center') ||
        (typo && !Array.isArray(typo) && typo === TypographyAlign.TEXT_LEFT && 'left') ||
        (typo && Array.isArray(typo) && typo.includes(TypographyAlign.TEXT_LEFT) && 'left') ||
        (typo && !Array.isArray(typo) && typo === TypographyAlign.TEXT_RIGHT && 'right') ||
        (typo && Array.isArray(typo) && typo.includes(TypographyAlign.TEXT_RIGHT) && 'right') ||
        (typo && !Array.isArray(typo) && typo === TypographyAlign.TEXT_JUSTIFIED && 'justify') ||
        (typo && Array.isArray(typo) && typo.includes(TypographyAlign.TEXT_JUSTIFIED) && 'justify') ||
        'left');
};
//# sourceMappingURL=TypographyAlign.js.map